import { render, staticRenderFns } from "./verSolicitud.vue?vue&type=template&id=71d97a30&scoped=true"
import script from "./verSolicitud.vue?vue&type=script&lang=js"
export * from "./verSolicitud.vue?vue&type=script&lang=js"
import style0 from "./verSolicitud.vue?vue&type=style&index=0&id=71d97a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d97a30",
  null
  
)

export default component.exports